import enums from '@/utils/enums';
import requestService from '@/services/request';
import { NOTIFICATIONS, ROLES, SOLICITATE_TYPE } from '../../utils/constants';
import moment from 'moment-timezone';
const promisesCache = {};

export default {
  data: () => ({
    inDelaySolicitationAllowed: false,
    hasLateReadySolicitations: false,
  }),

  methods: {
    async getLateSolicitations(contracts = null) {
      try {
        if (this.user.userRole !== ROLES.CLIENT_ROLE) return;
        if (!contracts) {
          if (!this.selectedUnit) {
            return;
          }
          const { LATE_SLIPS } = enums.financialModules;
          contracts = this.getAllowedContracts(
            LATE_SLIPS,
            this.selectedUnit.contracts
          );
        }

        const { sku } = this.selectedUnit;
        const params = {
          productSku: sku,
          contractIds: contracts.map((o) => o.id),
          contractTypes: contracts.map((o) => o.type),
          solicitationType: 'Late',
        };
        const url = `${process.env.PAYMENT_SLIP_API_URL}/query`;

        // const paramsKey = JSON.stringify(params)
        // if (!promisesCache[paramsKey] || moment().isAfter(promisesCache[paramsKey].validUntil)) {
        //   promisesCache[paramsKey] = {
        //     validUntil: moment().add(5, 'minutes').toISOString(),
        //     promise: requestService(
        //       url,
        //       'GET',
        //       {
        //         params,
        //         localErrorHandling: true
        //       }
        //     ).catch(err => {
        //       delete promisesCache[paramsKey]
        //       throw err
        //     }),
        //   }
        // }

        // const {
        //   items,
        //   solicitationAllowed
        // } = await promisesCache[paramsKey].promise

        const { items, solicitationAllowed } = await requestService(
          url,
          'GET',
          {
            params,
            localErrorHandling: true,
          }
        );

        this.inDelaySolicitationAllowed = solicitationAllowed;

        if (items) {
          const logSolicitations = [];

          const readySolicitations = items.reduce((ready, o) => {
            if (o.ready) {
              const [item] = o.items;
              ready.push(item);
            }
            if (o.logError || o.logGenerated || o.logExpired) {
              logSolicitations.push(o);
            }
            return ready;
          }, []);

          for (const solicitation of logSolicitations) {
            const slipContract = this.selectedUnit.contracts.find(
              (contract) => contract.id === solicitation.contractId
            );
            const solicitationDetails = solicitation.items[0];
            if (slipContract && solicitationDetails) {
              const {
                paymentTotal,
                solicitationCode,
                expirationDate,
                parcelIds,
              } = solicitationDetails;
              if (solicitation.logError || solicitation.logExpired) {
                const traceAction = solicitation.logError
                  ? enums.logTraceActions.latePaymentSlipSolicitationError
                  : enums.logTraceActions.latePaymentSlipSolicitationExpired;
                const traceInfo = {
                  contractId: slipContract.id,
                  contractType: slipContract.type,
                  detachedType: this.getContractTitle(slipContract),
                  paymentTotal,
                  solicitationCode,
                  expirationDate,
                  parcels: parcelIds,
                };
                this.createTrace(traceAction, traceInfo);
              } else if (solicitation.logGenerated) {
                const traceInfo = {
                  contractId: slipContract.id,
                  contractType: slipContract.type,
                  detachedType: this.getContractTitle(slipContract),
                  paymentTotal,
                  solicitationCode,
                  expirationDate,
                  parcels: parcelIds,
                };
                const traceAction =
                  enums.logTraceActions.latePaymentSlipSolicitationReady;
                this.createTrace(traceAction, traceInfo);
              }
            }
          }

          if (readySolicitations.length > 0) {
            this.$store.commit(
              NOTIFICATIONS.MUTATE_LATE_PAYMENT_SLIPS,
              readySolicitations
            );
            this.hasLateReadySolicitations = readySolicitations.some(
              (item) => item.solicitationType === SOLICITATE_TYPE.LATE
            );
          }

          return items;
        }
      } catch (err) {
        throw err;
      }
    },
    async sendSlipByEmailLate(item, email, fromHome = false) {
      console.log('sendSlipByEmailLate');

      const contractId = item.contractId;

      const data = {
        contractId,
        productCode: this.selectedUnit.product.code,
        blockCode: this.selectedUnit.block.code,
        unitCode: this.selectedUnit.unit.code,
        documentCode: item.documentCode,
        solicitationType: 'late',
        userEmail: email,
      };

      const url = process.env.SLIP_CHECK_FUNCTION;
      const res = await requestService(`${url}/sendSlipEmail`, 'POST', {
        data,
        useLoading: false,
        localErrorHandling: true,
      });

      const { emailSended } = res;
      if (emailSended) {
        const slipContract = this.selectedUnit.contracts.find(
          (contract) => contract.id === contractId
        );
        const traceInfo = {
          contractId: contractId,
          contractType: slipContract.type,
          detachedType: this.getContractTitle(slipContract),
          expirationDate: item.expirationDate,
          serieId: item.serieId,
          serieCode: item.serieCode,
          parcelCode: item.parcelCode,
          discountedValue: item.discountedValue,
          ready: item.ready,
          url: item.slipUrl,
        };
        const { logTraceActions } = enums;
        const traceAction =
          logTraceActions[`latePaymentSlipEmail${fromHome ? 'Home' : ''}`];
        this.createTrace(traceAction, traceInfo);
      } else {
        console.error('Payment slip not ready');
      }
      return res;
    },
    async sendSlipBySmsLate(item, cellphone, fromHome = false) {
      console.log('sendSlipBySmsLate');
      const contractId = item.contractId;

      const data = {
        contractId,
        productId: this.selectedUnit.product.id,
        blockCode: this.selectedUnit.block.code,
        unitCode: this.selectedUnit.unit.code,
        documentCode: item.documentCode,
        smsType: 'lateSlipRequested',
        userPhoneNumber: cellphone,
      };

      const url = process.env.SMS_API;
      return requestService(`${url}/addToQueue`, 'POST', {
        data,
        useLoading: false,
        localErrorHandling: true,
      })
        .then((res) => {
          const { count } = res;
          if (count) {
            const slipContract = this.selectedUnit.contracts.find(
              (contract) => contract.id === contractId
            );
            const traceInfo = {
              contractId: contractId,
              contractType: slipContract.type,
              detachedType: this.getContractTitle(slipContract),
              expirationDate: item.expirationDate,
              serieId: item.serieId,
              serieCode: item.serieCode,
              parcelCode: item.parcelCode,
              discountedValue: item.discountedValue,
              ready: item.ready,
              url: item.slipUrl,
              barcode: item.barcode,
              userCellphone: cellphone,
            };
            const { logTraceActions } = enums;
            const traceAction =
              logTraceActions[`latePaymentSlipSms${fromHome ? 'Home' : ''}`];
            this.createTrace(traceAction, traceInfo);
          }
          return res;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/modules/latePaymentSlip.js